import { Component, input, output, viewChild } from '@angular/core';
import { DropDownMultiselectComponent, DropdownMultiselectItem } from '@bayclubs/drop-down';

@Component({
    selector: 'app-camp-options-selector',
    templateUrl: './camp-options-selector.component.html',
    styleUrl: './camp-options-selector.component.scss',
    standalone: false,
})
export class CampOptionsSelectorComponent {
    isBusy = input.required<boolean>();

    parentCategoryDropdownItems = input.required<DropdownMultiselectItem[]>();
    campTypeDropdownItems = input.required<DropdownMultiselectItem[]>();

    parentCategoriesChanged = output<DropdownMultiselectItem[]>();
    campTypesChanged = output<DropdownMultiselectItem[]>();

    parentCategoryDropdown = viewChild('parentCategoryDropdown', { read: DropDownMultiselectComponent });
    campTypeDropdown = viewChild('campTypeDropdown', { read: DropDownMultiselectComponent });

    onParentCategoriesChanged(newCategories: DropdownMultiselectItem[]): void {
        this.parentCategoriesChanged.emit(newCategories);
    }

    onCampTypeChanged(newTypes: DropdownMultiselectItem[]): void {
        this.campTypesChanged.emit(newTypes);
    }

    adjustAllSelectedForCategories(): void {
        const parentCategories = this.parentCategoryDropdownItems();
        const allSelected = parentCategories.every((c) => c.selected);
        this.parentCategoryDropdown().allSelected = allSelected;
    }

    adjustAllSelectedForCampTypes(): void {
        const campTypes = this.campTypeDropdownItems();
        const allSelected = campTypes.every((c) => c.selected);
        this.campTypeDropdown().allSelected = allSelected;
    }
}
